export const primaryCategories = [
  'Accounting & Finance',
  'Automotive',
  'Beauty & Personal Care',
  'Construction & Real Estate',
  'Consulting & Professional Services',
  'E-commerce & Retail',
  'Education & Training',
  'Events & Entertainment',
  'Food & Beverage',
  'Health & Wellness',
  'Home Services',
  'Hospitality & Travel',
  'Legal Services',
  'Manufacturing & Industrial',
  'Marketing & Advertising',
  'Media & Publishing',
  'Non-Profit & NGO',
  'Pet Services',
  'Photography & Creative',
  'Software & Technology',
  'Sports & Fitness',
  'Telecommunications',
  'Transportation & Logistics',
  'Other',
];

export const foresightAgencies = [
  { id: 'brightedge', name: 'BrightEdge Digital', contact: 'Sarah Mitchell', email: 'sarah@brightedge.io', phone: '+1 (415) 555-0142', website: 'https://brightedge.io' },
  { id: 'rankboost', name: 'RankBoost Agency', contact: 'James Carter', email: 'james@rankboost.com', phone: '+1 (212) 555-0198', website: 'https://rankboost.com' },
  { id: 'searchpilot', name: 'SearchPilot Media', contact: 'Emily Zhang', email: 'emily@searchpilot.co', phone: '+1 (310) 555-0167', website: 'https://searchpilot.co' },
  { id: 'growthseo', name: 'GrowthSEO Partners', contact: 'Michael Torres', email: 'michael@growthseo.com', phone: '+1 (512) 555-0134', website: 'https://growthseo.com' },
  { id: 'visibilityhub', name: 'VisibilityHub', contact: 'Priya Sharma', email: 'priya@visibilityhub.io', phone: '+44 20 7946 0958', website: 'https://visibilityhub.io' },
  { id: 'organicreach', name: 'OrganicReach Co.', contact: 'David Kim', email: 'david@organicreach.co', phone: '+1 (646) 555-0189', website: 'https://organicreach.co' },
];

export const fontOptions = [
  // Sans Serif
  'Inter', 'Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Poppins', 'Source Sans Pro', 'Raleway', 'Oswald', 'Nunito', 'Ubuntu', 'PT Sans', 'Rubik', 'Work Sans', 'Fira Sans', 'Quicksand', 'Karla', 'Mukta', 'Hind', 'Noto Sans',
  // Serif
  'Playfair Display', 'Merriweather', 'Lora', 'PT Serif', 'Noto Serif', 'Crimson Text', 'EB Garamond', 'Libre Baskerville', 'Bitter', 'Domine', 'Arvo', 'Zilla Slab', 'Rokkitt',
  // Display
  'Bebas Neue', 'Righteous', 'Anton', 'Lobster', 'Abril Fatface', 'Comfortaa', 'Cinzel', 'Russo One', 'Fredoka One', 'Alfa Slab One',
  // Monospace
  'Roboto Mono', 'Space Mono', 'Fira Code', 'Inconsolata', 'Source Code Pro', 'IBM Plex Mono', 'Ubuntu Mono', 'PT Mono',
  // Handwriting
  'Pacifico', 'Caveat', 'Satisfy', 'Dancing Script', 'Permanent Marker', 'Amatic SC', 'Kalam', 'Shadows Into Light', 'Great Vibes'
];

export const majorCities = [
  'New York, NY', 'Los Angeles, CA', 'Chicago, IL', 'Houston, TX', 'Phoenix, AZ',
  'Philadelphia, PA', 'San Antonio, TX', 'San Diego, CA', 'Dallas, TX', 'San Jose, CA',
  'Austin, TX', 'Jacksonville, FL', 'Fort Worth, TX', 'Columbus, OH', 'Charlotte, NC',
  'San Francisco, CA', 'Indianapolis, IN', 'Seattle, WA', 'Denver, CO', 'Washington, DC',
  'Boston, MA', 'El Paso, TX', 'Nashville, TN', 'Detroit, MI', 'Oklahoma City, OK',
  'Portland, OR', 'Las Vegas, NV', 'Louisville, KY', 'Baltimore, MD', 'Milwaukee, WI',
  'Albuquerque, NM', 'Tucson, AZ', 'Fresno, CA', 'Mesa, AZ', 'Sacramento, CA',
  'Atlanta, GA', 'Kansas City, MO', 'Colorado Springs, CO', 'Omaha, NE', 'Raleigh, NC',
  'Miami, FL', 'Long Beach, CA', 'Virginia Beach, VA', 'Oakland, CA', 'Minneapolis, MN',
  'Tulsa, OK', 'Arlington, TX', 'Tampa, FL', 'New Orleans, LA', 'Wichita, KS',
  'Cleveland, OH', 'Bakersfield, CA', 'Aurora, CO', 'Anaheim, CA', 'Honolulu, HI',
  'Santa Ana, CA', 'Riverside, CA', 'Corpus Christi, TX', 'Lexington, KY', 'Henderson, NV',
  'Stockton, CA', 'Saint Paul, MN', 'Cincinnati, OH', 'St. Louis, MO', 'Pittsburgh, PA',
  'Greensboro, NC', 'Lincoln, NE', 'Anchorage, AK', 'Plano, TX', 'Orlando, FL',
  'Irvine, CA', 'Newark, NJ', 'Durham, NC', 'Chula Vista, CA', 'Toledo, OH',
  'Fort Wayne, IN', 'St. Petersburg, FL', 'Laredo, TX', 'Jersey City, NJ', 'Chandler, AZ',
  'Madison, WI', 'Lubbock, TX', 'Scottsdale, AZ', 'Reno, NV', 'Buffalo, NY',
  'Gilbert, AZ', 'Glendale, AZ', 'North Las Vegas, NV', 'Winston-Salem, NC', 'Chesapeake, VA',
  'Norfolk, VA', 'Fremont, CA', 'Garland, TX', 'Irving, TX', 'Hialeah, FL',
  'Richmond, VA', 'Boise, ID', 'Spokane, WA', 'Baton Rouge, LA', 'Des Moines, IA',
];

export const steps = [
  { number: 1, label: 'Business Info' },
  { number: 2, label: 'Ecosystem' },
  { number: 3, label: 'Business Portfolio' },
];